var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BuilderBtnItem',{attrs:{"icon":"save","title":"Save","disabled":_vm.disabledSaving,"icon-size":_vm.iconSize,"button-state":_vm.buttonState},on:{"click":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }